/* eslint-disable sonarjs/cognitive-complexity, complexity, no-prototype-builtins */
import compact from 'lodash/compact';
import map from 'lodash/map';
import Cookies from 'react-cookies';
import { PAYMENT_METHODS } from '../config/constants/payment';
import COOKIES from '../config/cookies/cookies';
import AdminFeeService from './adminFeeService';
import { formatDateForApi } from './productsService';
import { getUserLocationShortName } from './user';
import { MAX_VIP_COST, VIP_LIMIT } from './vipSubscribeHelper';

const paymentPayload = async ({
  service,
  provider,
  expressCheckout = false,
  expressDealCheckout = false,
  fastlaneFlow = false,
}) => {
  if (!provider) return null;

  const sessionSource = Cookies.load(COOKIES.sessionSource);
  if (service.isPostCheckout) {
    const payload = {
      cashAmount: service.totalAmountToPay,
      expressBuy: service.postageOnRedemption
        ? false
        : service.expressBuy || false,
      orderLineAddons: compact(
        map(service.addons, (addon) => {
          const addonPayload = {
            addonType: addon.addonType,
            orderLineId: addon.orderLineId,
          };

          // Handle gift design addon
          if (addon.giftingDesignId !== undefined) {
            addonPayload.giftingDesignId = addon.giftingDesignId;
          } else {
            // Handle other addons with product ID
            addonPayload.dealVoucherProductId =
              addon.dealVoucherProductId || addon.productId;
            addonPayload.productOrderId = addon.productOrderId;
          }

          return addonPayload;
        }),
      ),
      sendEmail: service.sendEmail,
      vipDiscountApplied:
        Boolean(service.basketDiscountForExistingVipUser) ||
        (service.vipOptInBasketDiscount > 0 && service.vipOptIn === true),
    };
    const purchaseSource = sessionSource
      ? `${sessionSource}_${service.addons[0].source}`
      : service.addons[0].source;

    payload.purchaseSource = purchaseSource;
    const expressPurchaseSource = expressDealCheckout
      ? 'deal'
      : expressCheckout
      ? 'checkout'
      : fastlaneFlow
      ? 'payPalFastlane'
      : '';
    payload.expressPurchaseSource = expressPurchaseSource;
    payload.paymentMethod = service.paymentMethod;
    payload.vipDiscountApplied =
      Boolean(service.basketDiscountForExistingVipUser) ||
      (service.vipOptInBasketDiscount > 0 && service.vipOptIn === true);
    payload.deviceData = service.deviceData;
    payload.nonce = service.nonce;
    payload.sendEmail = service.sendEmail;
    service.products = service.addons;

    return payload;
  } else {
    const vipProductId = service?.vipSubscriptionDetails?.productId;
    let isOmitVip = false;
    // same condition to remove VIP product as in VipSubscribe
    if (service.totalAmountToPay > VIP_LIMIT + MAX_VIP_COST) isOmitVip = true;

    const payload = {
      adminFeeApplied: service.products.some((product) => product.adminFee > 0),
      cashAmount: service.totalAmountToPay,
      expressBuy: service.expressBuy,
      expressPurchaseSource: expressDealCheckout
        ? 'deal'
        : fastlaneFlow
        ? 'payPalFastlane'
        : expressCheckout
        ? 'checkout'
        : '',
      location: getUserLocationShortName(),
      orderLines: compact(
        map(service.products, (product) => {
          if (
            product.quantity <= 0 ||
            product.soldOut ||
            (isOmitVip && product.id === vipProductId)
          )
            return null;
          const deliveryOptionType =
            product.deliveryOptionType && !service.isRedeemPostage
              ? product.deliveryOptionType.hasOwnProperty('deliveryOptionType')
                ? product.deliveryOptionType.deliveryOptionType
                : product.deliveryOptionType
              : null;
          const orderLinesPayload = {
            dealVoucherProductId: product.payDeposit
              ? product.depositProduct.id
              : product.id,
            deliveryOptionType,
            gift: product.gift,
            giftClaim: product.giftClaim,
            gifting: product.gifting,
            giftPack: product.giftPack,
            giftWrap: product.giftWrap,
            orderAddons: product.orderAddons,
            quantity: product.quantity,
          };

          if (product.numberOfNights)
            orderLinesPayload.numberOfNights = product.numberOfNights;

          if (product.travel) orderLinesPayload.travel = product.travel;

          if (product.checkInDate) {
            orderLinesPayload.calendarCheckInDate = formatDateForApi(
              product.checkInDate,
            );
          }
          if (product.checkOutDate) {
            orderLinesPayload.calendarCheckOutDate = formatDateForApi(
              product.checkOutDate,
            );
          }

          return orderLinesPayload;
        }),
      ),
      orderSummaryIdentifier: service.orderSummaryIdentifier || null,
      postageDiscountAmount: service.postageDiscount || null,
      postageOnCheckoutRule: service.postageOnCheckoutRule,
      postageOnRedemption: service.postageOnRedemption,
      promoCode: service.promoCode,
      purchaseSource: sessionSource || null,
      sendEmail: service.sendEmail,
      vipDiscountApplied:
        Boolean(service.basketDiscountForExistingVipUser) ||
        (service.vipOptInBasketDiscount > 0 && service.vipOptIn === true),
      vipOptedIn: service.vipOptIn || false,
      vipOptInType: service.vipOptInType || '',
      walletCreditsVO: service.walletCreditsVO,
      walletUsed: service.walletUsed,
    };

    if (
      service.allowSubscription === true ||
      service.allowSubscription === false
    ) {
      payload.allowSubscription = service.allowSubscription;
    }

    payload.nonce = service.nonce;
    payload.deviceData = service.deviceData;
    payload.paymentMethod = service.paymentMethod;
    if (service.paymentMethod === PAYMENT_METHODS.card) {
      payload.token = service.token;
    }
    payload.sendEmail = service.sendEmail;

    const response = await AdminFeeService.getAdminFee(
      service.id,
      payload.orderLines[0],
    );

    if (payload.adminFeeApplied && payload.expressBuy) {
      payload.cashAmount = response.totalAmount;
    }

    if (response.vipDiscountAllowed) {
      const adminFee =
        response.totalAdminFee === null
          ? response.postagePrice * response.quantity
          : response.totalAdminFee;
      payload.cashAmount = response.vipPrice * response.quantity + adminFee;
      payload.vipDiscountApplied = response.vipDiscountAllowed;
    }

    return JSON.stringify(payload);
  }
};

export default paymentPayload;
